module.exports = __webpack_public_path__ + "img/pickup.3acf3cae.png";